import { Directive, ElementRef, Output, EventEmitter, AfterViewInit } from '@angular/core';
import Hammer from 'hammerjs';

@Directive({
    selector: '[appHammerGesture]',
    standalone: false
})
export class HammerDirective implements AfterViewInit {
  @Output() swipeLeft = new EventEmitter<void>();
  @Output() swipeRight = new EventEmitter<void>();

  constructor(private el: ElementRef) {}

  ngAfterViewInit(): void {
    const hammer = new Hammer(this.el.nativeElement);

    // Configure swipe gestures
    hammer.get('swipe').set({ direction: Hammer.DIRECTION_HORIZONTAL });

    hammer.on('swipeleft', () => this.swipeLeft.emit());
    hammer.on('swiperight', () => this.swipeRight.emit());
  }
}
